import { type CVCResponse } from "./types";
import { fetchAPI2 } from "../fetchAPI2";
import { simulateApiError } from "../errors";

export const _retrieveCVC = async (cvc_id: string) => {
  const data = await fetchAPI2<CVCResponse>(`/cvc/${cvc_id}`, {unauthenticated: true});

  return data;
};
